<app-header></app-header>
<!--<app-truck-form></app-truck-form>-->
<!--<app-tco></app-tco>-->
<div class="fill-space"></div>
<router-outlet (activate)="onActivate()"></router-outlet>
<!--<app-tco></app-tco>-->
<!--<app-footer *ngIf="route.url !== '/home'"></app-footer>-->
